import _sfc_main from "./WsCarySpinner.vue.es2.js";
/* empty css                      */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.es.js";
const WsCarySpinner = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-2bfc88f6"]]);
export {
  WsCarySpinner as default
};
//# sourceMappingURL=WsCarySpinner.vue.es.js.map
